module.exports = __webpack_public_path__ + "static/media/9.fd7b3297.jpg";